import * as React from "react";
import { forwardRef } from "react";
const SvgEye = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 8C15 9 13 13 8 13C3 13 1 9 1 8C1 7 3 3 8 3C13 3 15 7 15 8Z", stroke: "currentColor", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z", stroke: "currentColor", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
